import React, { useEffect, useState } from 'react';
import { Select, Space } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { apiClient } from 'Utils/api';

const { Option } = Select;

interface Language {
  code: string;
  name: string;
  nativeName: string;
  isActive: boolean;
  isDefault: boolean;
}

interface LanguageSelectorProps {
  value: string;
  onChange: (languageCode: string) => void;
  style?: React.CSSProperties;
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({ value, onChange, style }) => {
  const [languages, setLanguages] = useState<Language[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchLanguages();
  }, []);

  const fetchLanguages = async () => {
    setLoading(true);
    try {
      const response = await apiClient.get('/api/admin/languages');
      const allLanguages = response.data.languages || [];
      // Only show active languages
      setLanguages(allLanguages.filter((lang: Language) => lang.isActive));
    } catch (error) {
      console.error('Error fetching languages:', error);
      // Fallback to default languages
      setLanguages([
        { code: 'de', name: 'German', nativeName: 'Deutsch', isActive: true, isDefault: true },
        { code: 'en', name: 'English', nativeName: 'English', isActive: true, isDefault: false },
      ]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Space style={style}>
      <GlobalOutlined style={{ fontSize: 16, color: '#1890ff' }} />
      <Select
        value={value}
        onChange={onChange}
        loading={loading}
        style={{ width: 150 }}
        placeholder="Sprache wählen"
      >
        {languages.map((lang) => (
          <Option key={lang.code} value={lang.code}>
            <span style={{ marginRight: 8 }}>{lang.nativeName}</span>
            {lang.isDefault && <span style={{ fontSize: 10, color: '#666' }}>(Standard)</span>}
          </Option>
        ))}
      </Select>
    </Space>
  );
};

export default LanguageSelector;
